import React from 'react';
import SecurityRow from './securityRow/index';

const SecurityList = ({
    data,
    width,
    addFavouriteSecurity,
    onSecuritySelect,
    onSaveSecurity,
    onDeleteSecurity,
    showSecurityLoader
}) => {
    return (
        <div className="app-main-content">
            {data.map((data, index) => <SecurityRow key={index} security={data}
                    width={width}
                    onDeleteSecurity={onDeleteSecurity}
                    onSaveSecurity={onSaveSecurity}
                    showSecurityLoader={showSecurityLoader}
                    addFavouriteSecurity={addFavouriteSecurity}
                    onSecuritySelect={onSecuritySelect}
                />
            )}
        </div>
    )
};

export default SecurityList;


// WEBPACK FOOTER //
// ./components/Agile/security/securityList/index.js